import { ReactNode } from "react";
import styles from "./modal.module.css";

interface ModalProps {
  isOpen: boolean;
  title: string;
  body: ReactNode;
  modalWidth?: string;
  modalHeight?: string;
  closeModal?: (event: React.MouseEvent<HTMLImageElement>) => void;
  footerElementOutsideModalBody?: ReactNode;
  modalClassNames?: string;
  customStyles?: object;
  isCloseButtonRequired?: boolean;
  withOverlay?: boolean;
}

const Modal = ({
  isOpen,
  title,
  body,
  closeModal,
  modalWidth,
  modalHeight,
  footerElementOutsideModalBody,
  modalClassNames,
  customStyles,
  isCloseButtonRequired = true,
  withOverlay = true,
}: ModalProps) => {
  const widthClass = modalWidth ? modalWidth : "md:w-[439px]";
  const heightClass = modalHeight ? modalHeight : "xs:h-auto";

  if (!withOverlay) {
    return isOpen && <div onClick={(event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation()}>{body}</div>;
  }

  return (
    isOpen && (
      <div
        className="fixed flex flex-col justify-center items-center z-[1003] top-0 left-0 bottom-0 right-0 bg-[rgba(0,0,0,0.7)] cursor-default"
        onClick={(event: React.MouseEvent<HTMLDivElement>) => event.stopPropagation()}>
        <div
          className={`${modalClassNames} bg-white ${widthClass} ${heightClass} md:relative py-8 md:px-8 xs:px-4 overflow-hidden max-h-[650px]`}
          style={customStyles}>
          {isCloseButtonRequired && (
            <p className="w-full flex justify-end absolute right-3 top-3">
              <span
                className={`duration-[.2s] cursor-pointer hover:rotate-90 ${styles.crossIcon}`}
                onClick={closeModal}
              />
            </p>
          )}
          {title && title !== "" && <h1 className={`text-center ${styles.headerTitle}`}>{title}</h1>}
          {body}
        </div>
        {footerElementOutsideModalBody}
      </div>
    )
  );
};

export default Modal;
